<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Пакеты</h3>
            </v-flex>
            <v-flex xs12 sm6>
                <v-btn
                        class="mb-2"
                        @click.native="send()"
                >
                    <v-icon class="mr-2">mdi-send</v-icon>
                    Отправить
                </v-btn>
                <v-btn
                        class="mb-2"
                        @click.native="ask()"
                >
                    <v-icon class="mr-2">mdi-send</v-icon>
                    Получить ответы
                </v-btn>
                <v-btn
                        class="mb-2"
                        @click.native="preparationsQuittances()"
                >
                    <v-icon class="mr-2">mdi-send</v-icon>
                    Сформировать пакеты на квитирование
                </v-btn>

            </v-flex>
            <v-flex xs12 sm12 md12>
                <v-data-table
                        :items="packages.results"
                        :server-items-length="packages.last_page"
                        :loading="listLoading.includes('GMPSendPackages') || listLoading.includes('GMPPreparationsQuittances') || listLoading.includes('GMPAskPackages')"
                        hide-default-footer
                        v-model="selected"
                        :headers="headers"
                        no-results-text="Нет отфильтрованных данных"
                        class="elevation-1"
                        item-key="id"
                        show-select
                        :single-select="false"
                >
                    <template v-slot:item.date_created="{ item }">
                        {{item.date_created|date_time}}
                    </template>
                    <!--<template v-slot:item.data-table-select="{ isSelected, select }">-->
                        <!--<v-simple-checkbox color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox>-->
                    <!--</template>-->
                    <!--<template v-slot:item="{ item, isSelected, select }">-->
                        <!--<tr :key="item.id">-->
                        <!--<td>-->
                            <!--<v-simple-checkbox :value="isSelected" @input="select($event)"></v-simple-checkbox>-->
                        <!--</td>-->
                        <!--<td>{{ item.id }}</td>-->
                        <!--<td>{{ item.date_created|date_time }}</td>-->
                        <!--<td>{{ item.type.name }}</td>-->
                        <!--<td>{{ item.status.name }}</td>-->
                        <!--<td>{{ item.count_prepare_charge }}</td>-->
                        <!--</tr>-->
                    <!--</template>-->
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            key="pagination"
                            v-model="pagination.page"
                            :length="packages.last_page"
                    ></v-pagination>
                </div>
            </v-flex>
            <router-view></router-view>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: 'Код',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Дата создания',
          align: 'start',
          sortable: false,
          value: 'date_created'
        },
        {
          text: 'Вид сведений',
          align: 'start',
          sortable: false,
          value: 'type.name'
        },
        {
          text: 'Статус',
          align: 'start',
          sortable: false,
          value: 'status.name'
        },
        {
          text: 'Количество',
          align: 'start',
          sortable: false,
          value: 'count_prepare_charge'
        }
      ],
      selected: [],
      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      }
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    packages () {
      return this.$store.getters['gis_gmpPackage/packages']
    }
    // selected () {
    //   return this.$store.getters['gis_gmpChargeForPreparation/selected']
    // }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize () {
      this.$store.dispatch('gis_gmpPackage/fetchPackages', {
        pageId: this.pagination.page
      })
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    send () {
      let ides = this.selected.map(function (item) {
        return item.id
      })
      this.$store.dispatch('gis_gmpPackage/sendPackages', {
        pageId: this.pagination.page,
        ides: ides
      })
      this.pagination.page = 1
    },
    ask () {
      this.$store.dispatch('gis_gmpPackage/askPackages')
      this.pagination.page = 1
    },
    preparationsQuittances () {
      this.$store.dispatch('gis_gmpPackage/preparationsQuittances')
      this.pagination.page = 1
    }

  },
  created: function () {
    this.initialize()
  }
}
</script>

<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }

    th {
        vertical-align: top
    }

    .bloc_inline {
        display: inline-block;
    }
</style>
